<template>
  <div class="chart" :style="{height:  height ? height + 'px' : '138px'}">
    <svg :class="this.$parent.full ? 'small' : 'big'" :width="height || '138px'" :height="height ||  '60px'" viewBox="0 0 120 94" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <linearGradient x1="7.11649466%" y1="38.8078124%" x2="100.169943%" y2="54.7303819%" id="linearGradient-1">
          <stop stop-color="#E62B28" offset="0%"></stop>
          <stop stop-color="#E83A2B" offset="2%"></stop>
          <stop stop-color="#EE6D34" offset="8%"></stop>
          <stop stop-color="#F39A3B" offset="15%"></stop>
          <stop stop-color="#F7BE42" offset="22%"></stop>
          <stop stop-color="#FBDB47" offset="28%"></stop>
          <stop stop-color="#FDEF4A" offset="35%"></stop>
          <stop stop-color="#FFFB4C" offset="42%"></stop>
          <stop stop-color="#FFFF4D" offset="48%"></stop>
          <stop stop-color="#FDFF4C" offset="63%"></stop>
          <stop stop-color="#F5FF49" offset="71%"></stop>
          <stop stop-color="#E7FF44" offset="77%"></stop>
          <stop stop-color="#D4FF3C" offset="82%"></stop>
          <stop stop-color="#BBFF32" offset="87%"></stop>
          <stop stop-color="#9DFF26" offset="91%"></stop>
          <stop stop-color="#79FF17" offset="95%"></stop>
          <stop stop-color="#50FF07" offset="99%"></stop>
          <stop stop-color="#3FFF00" offset="100%"></stop>
        </linearGradient>
        <path d="M106.54201,93.3314072 L103.91976,91.4133378 C102.917214,90.686118 102.673877,89.3016119 103.369088,88.2802019 C108.922945,80.0550617 111.958852,70.4088288 112.109921,60.5072517 C112.278552,42.0176295 102.500055,24.8431864 86.4578962,15.4533688 C70.4157371,6.06355113 50.5471009,5.8848957 34.3363106,14.9847002 C18.1255203,24.0845047 8.0353806,41.0802924 7.86674947,59.5699146 C7.86925366,61.4923917 7.97721719,63.4133065 8.19016028,65.3241227 C8.32602164,66.5465603 7.46569176,67.6574665 6.24095458,67.8410463 L3.0155873,68.335752 C2.39899378,68.4217692 1.77348742,68.2576788 1.28014406,67.8804896 C0.78680069,67.5033004 0.467168709,66.9447785 0.393337473,66.3308922 C0.13548973,64.0862676 0.00417251312,61.8290894 0,59.5699146 C0.019923584,43.3095903 6.72512496,27.7622659 18.5633674,16.5271066 C30.4016098,5.29194731 46.3464628,-0.6569064 62.7067341,0.0576896801 C94.3485486,1.44633719 120.448675,29.0109903 119.994152,60.4551774 C119.852351,71.9758658 116.321958,83.2041287 109.837304,92.7585901 C109.487239,93.2815251 108.936374,93.6388958 108.31346,93.7471762 C107.690546,93.8554566 107.05232,93.7046778 106.54201,93.3314072 Z" id="path-2"></path>
        <circle :id="'path-4'+this.cl" class="circle" :style="{transform: 'rotate(' + this.percentCounter(this.percent, 1) + 'deg)'}" cx="60" cy="60" r="60"></circle>
        <mask :id="'mask-5'+this.cl" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="120" height="120" fill="white">
          <use :xlink:href="'#path-4'+this.cl"></use>
        </mask>
        <circle :id="'path-6'+this.cl" class="circle" :style="{transform: 'rotate(' + this.percentCounter(this.percent, 1.5) + 'deg)'}" cx="60" cy="60" r="60"></circle>
        <mask :id="'mask-7'+this.cl" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="120" height="120" fill="white">
          <use :xlink:href="'#path-6'+this.cl"></use>
        </mask>
        <circle :id="'path-8'+this.cl" class="circle" :style="{transform: 'rotate(' + this.percentCounter(this.percent, 4) + 'deg)'}" cx="60" cy="60" r="60"></circle>
        <mask :id="'mask-9'+this.cl" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="120" height="120" fill="white">
          <use :xlink:href="'#path-8'+this.cl"></use>
        </mask>
      </defs>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Oval">
          <g>
            <mask :id="'mask-3'+this.cl" fill="white">
              <use xlink:href="#path-2"></use>
            </mask>
            <use id="Mask" fill="url(#linearGradient-1)" fill-rule="nonzero" xlink:href="#path-2"></use>
            <g stroke-dasharray="90,270" :mask="'url(#mask-3'+this.cl+')'" stroke="#494F6B" stroke-width="18">
              <use :mask="'url(#mask-5'+this.cl+')'" :xlink:href="'#path-4'+this.cl"></use>
            </g>
            <g stroke-dasharray="90,270" :mask="'url(#mask-3'+this.cl+')'" stroke="#494F6B" stroke-width="18">
              <use :mask="'url(#mask-7'+this.cl+')'" :xlink:href="'#path-6'+this.cl"></use>
            </g>
            <g stroke-dasharray="90,270" :mask="'url(#mask-3'+this.cl+')'" stroke="#494F6B" stroke-width="18">
              <use :mask="'url(#mask-9'+this.cl+')'" :xlink:href="'#path-8'+this.cl"></use>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <div class="arrow" :style="arrowStyle">
      <div class="arrow__arrow"></div>
      <div class="arrow__dot"></div>
    </div>
    <span class="info" :style="{fontSize: height ?  height * 0.36 + 'px' : '50px'}">
      <span class="number">{{data}}</span>
      <span class="name">{{this.pluralize(data, name)}}</span>
    </span>
  </div>
</template>

<script>
  export default {
    name: "chart",
    props: {
      percent: Number,
      data: Number,
      name: Array,
      cl: String,
      height: Number
    },
    methods: {
      percentCounter(p, addDeg) {
        let a;
        a = (p * 2.24 - 224) / addDeg + 51;
        return a
      },
      percentCounterArrow(p) {
        let a;
        a = p * 2.24 - 99;
        return a
      },
      pluralize(n, text_forms) {
        n = Math.abs(n) % 100; var n1 = n % 10;
        if (n > 10 && n < 20) { return text_forms[2]; }
        if (n1 > 1 && n1 < 5) { return text_forms[1]; }
        if (n1 === 1) { return text_forms[0]; }
        return text_forms[2];
      }
    },
    computed: {
      arrowStyle() {
        let dotDiameter;
        if (this.height < 50) {
          dotDiameter = 3
        } else if (this.height < 75) {
          dotDiameter = 5
        } else if (this.height < 100) {
          dotDiameter = 7
        } else {
          dotDiameter = 9
        }
        return [
          {transform: 'rotate(' + this.percentCounterArrow(this.percent) + 'deg)'},
          {marginLeft: this.height ? (this.height - dotDiameter) / 2 + 'px' : '64.5px'},
          {marginTop: this.height ? (this.height - dotDiameter) / 2 + this.height/12 + 'px' : '64.5px'},
          {height: dotDiameter + 'px'},
          {width: dotDiameter + 'px'}
          ]
      }
    }
  }
</script>

<style scoped lang="sass">
  .circle
    transform-origin: 60px 60px

  .chart
    position: relative
    display: flex
    flex-flow: column

  .arrow
    position: absolute
    display: flex
    flex-flow: column
    align-items: center
    justify-content: flex-end
    height: 100%
    width: 100%
    &__dot
      height: 100%
      width: 100%
      border-radius: 50%
      background: white
      flex-shrink: 0
    &__arrow
      height: 400%
      width: calc(100% / 3)
      background: white
      border-radius: 2px
      margin-bottom: -50%
      flex-shrink: 0

  .info
    position: absolute
    left: 0
    bottom: 0
    line-height: 1

  .number
    font-size: 1em
    font-weight: bold

  .name
    font-size: .3em
    margin-left: .35em

</style>
